module.exports = __webpack_public_path__ + "img/mgm_1200_2024.edc91609.jpg";